<template>
    <div class="col-md-4 col-sm-12">
      <b-card-header header-tag="header" class="p-2" style="height: 38px">
        <b><span>Produktstruktur</span></b>
      </b-card-header>
      <div class="tree-container col-md-4 col-sm-12 p-0" v-if="true">
        <TreeChildren v-for="children in productTree.children" :children="children" :key="children.id"></TreeChildren>
      </div>
    </div>
</template>

<script>
    import TreeChildren from "./TreeChildren";

        export default {
                name: "ProductTree",
                components: {TreeChildren },
                data: function () {
                    return {
                        isValidating: false,
                        maxStklId: '',
                    };
                },
                created() {
                        this.initProductTree();
                },
                computed: {
                        csrfToken: function () {
                                return this.$store.getters.csrfToken;
                        },
                        productTree: function () {
                                return this.$store.getters.productTree;
                        },
                        userData: function() {
                                return this.$store.getters.getUserData;
                        },
                },
            methods: {
                    initProductTree() {
                        this.$store.dispatch('initProductTree', this.$i18n.locale);
                    },
            },
        }

</script>

<style scoped>

</style>